import React, { useEffect, useState } from 'react'
import bg from '../../assests//images/backgrounds/bg.jpg'
import bg1 from '../../assests//images/backgrounds/bg1.jpg'
import bg2 from '../../assests//images/backgrounds/bg2.jpg'
import bg3 from '../../assests//images/backgrounds/bg3.jpg'
import bg5 from '../../assests//images/backgrounds/bg5.jpg'
import bg6 from '../../assests//images/backgrounds/bg6.jpg'
import bg7 from '../../assests//images/backgrounds/bg7.jpg'
import bg8 from '../../assests//images/backgrounds/bg8.jpg'
import { useTranslation } from 'react-i18next';
import './mainsection.css'


function HeroSection() {
  const { t } = useTranslation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const images = [bg, bg1, bg2, bg3, bg5,bg6, bg7, bg8];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      ); // Change image index
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
        <main className="main-section">
          <div
            style={{
              backgroundImage: `url(${images[currentImageIndex]})`,
              transition: 'background-image 3s ease-in-out' // Add transition property here
            }}
            className="main-background-section"
          ></div>
         {/* Preload images */}
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`preload-${index}`}
              style={{ display: 'none' }}
              onLoad={handleImageLoad}
            />
          ))}
        </main>

  )
}

export default HeroSection